import Iconify from '../../components/iconify';

const lockIcon = <Iconify icon="solar:lock-keyhole-minimalistic-bold" width={16} sx={{ color: 'text.disabled' }} />;

export function isOnboardingCompany(user) {
  const id = user?.data?.current_company;
  return user?.data?.companies?.[id]?.status === 'onboarding';
}

const locked = ({ children, ...item }) => ({
  ...item,
  path: item.path === '#' && children?.length ? children[0].path : item.path,
  info: lockIcon,
});

export function lockNavForOnboarding(groups, companyId) {
  return [
    { items: [{ title: 'Onboarding', path: `/onboarding/${companyId}`, icon: <Iconify icon="solar:clipboard-check-bold-duotone" sx={{ width: 24, height: 24 }} /> }] },
    ...groups.map((group) => ({ ...group, items: group.items.map(locked) })),
  ];
}
